import { DocumentLine } from '@/api/documents/documents.types.ts';
import CardHeader from '@/components/base/card/card-header.component';
import Card from '@/components/base/card/card.component';
import { CircularLoaderContainer } from '@/components/base/circular-loader-container.component';
import { formatMoneyString } from '@/utils/format-money-string';
import { Inventory2 as Inventory2Icon } from '@mui/icons-material';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

export default function OrderItems({
  items,
  isPending,
}: {
  items: DocumentLine[];
  isPending: boolean;
}) {
  if (isPending) {
    return (
      <Card>
        <CardHeader title="Bestellpositionen" />
        <CircularLoaderContainer />
      </Card>
    );
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <CardHeader icon={<Inventory2Icon />} title="Bestellpositionen" />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Artikelnummer</TableCell>
              <TableCell>Artikelname</TableCell>
              <TableCell>Menge</TableCell>
              <TableCell>Preis</TableCell>
              <TableCell>Gesamtpreis</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item) => (
              <TableRow key={item.lineNum ?? item.itemCode}>
                <TableCell>{item.itemCode}</TableCell>
                <TableCell>{item.itemDescription}</TableCell>
                <TableCell>{item.quantity}</TableCell>
                <TableCell align="right">
                  {formatMoneyString(item.price)}
                </TableCell>
                <TableCell align="right">
                  {formatMoneyString(item.lineTotal)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
